import 'twin.macro';
import React from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { CheckIcon as Check } from '@heroicons/react/20/solid';
import Body from './Body';
import { useAtom } from 'jotai';
import { Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import useSendToCMS from '@teetsh/app/src/queries/edt/useSendToCMS';
import { sendEDTToCMSPayloadAtom } from './atom';
import { ClassroomNiveauMapping } from '@teetsh/app/src/containers/EmploiDuTemps/EDT/Sidebar/EDTSendToCMSModal/types';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import { useTranslation } from 'react-i18next';
import { useScholarSystem } from 'queries/user/useScholarSystem';
import {
  ScholarSystems,
  getNiveauFromScholarSystemOrDefault,
} from 'containers/scholarSystem';

interface FormPayload {
  classroomsNiveauxMapping: ClassroomNiveauMapping[];
  destEDTId: string;
}

export function EDTSendToCMSModal() {
  const sendToCMS = useSendToCMS();
  const allClassrooms = useClassrooms();
  const { scholarSystem = ScholarSystems.FR } = useScholarSystem();
  const { t } = useTranslation(['common', 'emploiDuTemps']);
  const [modalPayload, setModalPayload] = useAtom(sendEDTToCMSPayloadAtom);
  const onClose = () => setModalPayload(undefined);
  if (!modalPayload) {
    return null;
  }
  return (
    <Dialog
      title={t('emploiDuTemps:sendToCMSModalTitle')}
      isOpen={!!modalPayload}
      onClose={onClose}
    >
      <Form<FormPayload>
        keepDirtyOnReinitialize
        initialValues={{
          classroomsNiveauxMapping: allClassrooms.map(cl => ({
            classroom: cl,
            niveau: getNiveauFromScholarSystemOrDefault(
              scholarSystem,
              cl.degree,
            ).niveau,
          })),
          destEDTId: modalPayload?.edt.id!,
        }}
        onSubmit={values =>
          sendToCMS({
            destEDTId: values.destEDTId,
            edtId: modalPayload?.edt.id,
            classroomsNiveauxMapping: values.classroomsNiveauxMapping.map(
              ({ classroom, niveau }) => ({
                classroomId: classroom.id,
                niveau,
              }),
            ),
          })
            .then(() => setModalPayload(undefined))
            .catch(() => ({
              [FORM_ERROR]: t('common:messages.genericError'),
            }))
        }
      >
        {({ handleSubmit, submitting, submitError }) => (
          <form onSubmit={handleSubmit}>
            <Dialog.Body>
              <Body />
              {submitError && (
                <div tw="mt-8 text-right text-danger-moderate mb-3 font-medium">
                  {submitError}
                </div>
              )}
            </Dialog.Body>
            <Dialog.Footer>
              <Button minimal large type="button" onClick={onClose}>
                {t('common:buttons.cancel')}
              </Button>
              <Button
                type="submit"
                loading={submitting}
                large
                intent="primary"
                icon={Check}
              >
                {t('common:buttons.validate')}
              </Button>
            </Dialog.Footer>
          </form>
        )}
      </Form>
    </Dialog>
  );
}
